import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataProcessors = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.546,
	height: 20.072,
	viewBox: "0 0 18.546 20.072",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_3232",
		"data-name": "Group 3232",
		transform: "translate(-97 -2143)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2781",
				"data-name": "Path 2781",
				d: "M100.17,2164.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2",
				transform: "translate(0 -5.006)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2782",
				"data-name": "Path 2782",
				d: "M103.526,2164.578v1.085l1.936.554a1.072,1.072,0,0,1,.734.972v.381H102",
				transform: "translate(-1.067 -4.998)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse_89",
				"data-name": "Ellipse 89",
				cx: 2.289,
				cy: 2.496,
				rx: 2.289,
				ry: 2.496,
				transform: "translate(99.026 2154.943)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2783",
				"data-name": "Path 2783",
				d: "M104.069,2161.073a1.309,1.309,0,0,1-1.884-.4,2.194,2.194,0,0,1-2.62.328",
				transform: "translate(-0.49 -4.072)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2784",
				"data-name": "Path 2784",
				d: "M113.17,2164.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2",
				transform: "translate(-3.083 -5.006)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2785",
				"data-name": "Path 2785",
				d: "M116.526,2164.594v1.073l1.936.554a1.072,1.072,0,0,1,.734.972v.381H115",
				transform: "translate(-4.15 -5.002)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse_90",
				"data-name": "Ellipse 90",
				cx: 2.289,
				cy: 2.496,
				rx: 2.289,
				ry: 2.496,
				transform: "translate(108.943 2154.943)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2786",
				"data-name": "Path 2786",
				d: "M117.057,2161.07a1.3,1.3,0,0,1-1.871-.4,2.194,2.194,0,0,1-2.62.328",
				transform: "translate(-3.573 -4.072)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_3233",
				"data-name": "Group 3233",
				transform: "translate(102.459 2143.5)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2787",
						"data-name": "Path 2787",
						d: "M106.67,2177.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2",
						transform: "translate(-104 -2172.949)",
						fill: "#dad9ef",
						stroke: "#618cf5",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2788",
						"data-name": "Path 2788",
						d: "M110.026,2177.609v1.061l1.936.554a1.072,1.072,0,0,1,.734.972v.381h-4.2",
						transform: "translate(-105.067 -2172.949)",
						fill: "#dad9ef",
						stroke: "#618cf5",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse_91",
						"data-name": "Ellipse 91",
						cx: 2.289,
						cy: 2.496,
						rx: 2.289,
						ry: 2.496,
						transform: "translate(1.526)",
						fill: "#dad9ef",
						stroke: "#618cf5",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2789",
						"data-name": "Path 2789",
						d: "M110.557,2174.051a1.289,1.289,0,0,1-1.871-.381,2.194,2.194,0,0,1-2.62.328",
						transform: "translate(-104.49 -2172.015)",
						fill: "#dad9ef",
						stroke: "#618cf5",
						strokeLinejoin: "round",
						strokeWidth: 1
					})
				]
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_415",
				"data-name": "Line 415",
				x2: 1.316,
				y2: 1.144,
				transform: "translate(108.04 2152.654)",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2790",
				"data-name": "Path 2790",
				d: "M1.312,0,0,1.144",
				transform: "translate(103.388 2152.654)",
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeWidth: 1
			})
		]
	})
});
export default SvgDataProcessors;
